<template>
  <nav class="sticky top-0 flex items-center justify-between bg-black h-[3.125rem] tablet-rotated:h-[3.75rem] w-full z-50">
    <div class="w-1/4 py-[0.813rem] pl-[0.938rem] laptop:py-[0.938rem] laptop:pl-[1.25rem]">
      <a :href="SERATO_COM_URL?.toString()">
        <img src="https://m.cdn.sera.to/logos/logo.svg" alt="Logo" class="h-6 tablet-rotated:h-[1.875rem]">
      </a>
    </div>
  </nav>
</template>
<script setup lang="ts">

const SERATO_COM_URL = import.meta.env.VITE_APP_CLIENT_URI_SERATO_COM
</script>
